import React from 'react';
import { Flex, TextV2, IconV2, TooltipV2, FormControl, InputV2, Box } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';

interface LegacyAddressProps
  extends Readonly<{
    value?: Maybe<string>;
  }> {}

const LegacyAddress: React.FC<LegacyAddressProps> = ({ value }) => {
  const { tq } = useTranslation('stationery');

  if (!value) {
    return null;
  }

  return (
    <FormControl
      label={
        <Flex columnGap={1}>
          <TextV2
            typographyVariant="label2"
            fontWeight={600}
            color="mono14"
          >{tq`Imported Address`}</TextV2>
          <TooltipV2
            content={<Box width="300px">{tq`We found this address in your guest’s details. It’s for reference only, please enter the formatted address below for printing.`}</Box>}
            placement="right"
            onMouseEnterDelay={500}
          >
            <IconV2
              size="sm"
              color="mono14"
            >
              <Info />
            </IconV2>
          </TooltipV2>
        </Flex>
      }
      isDisabled
    >
      <InputV2
        value={value}
        readOnly
        disabled
      />
    </FormControl>
  );
};

export default LegacyAddress;
